import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { CourseRoutingModule } from './course-routing.module';
import { CourseListComponent } from './course-list/course-list.component';
import { CourseCreateComponent } from './course-create/course-create.component';
import { CourseEditComponent } from './course-edit/course-edit.component';
import { CourseViewComponent } from './course-view/course-view.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgmCoreModule } from '@agm/core';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ManageComponent } from './manage/manage.component';
import { CourseAddEditComponent } from './course-add-edit/course-add-edit.component';
import { QuillModule } from 'ngx-quill';
import { MatMenuModule } from '@angular/material/menu';
import { CourseReportsComponent } from './course-reports/course-reports.component';
import { CourseReportsChartComponent } from './course-reports-chart/course-reports-chart.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { PasswordModalComponent } from './password-modal/password-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
@NgModule({
  declarations: [
    CourseListComponent,
    CourseCreateComponent,
    CourseEditComponent,
    CourseViewComponent,
    ManageComponent,
    CourseAddEditComponent,
    CourseReportsComponent,
    CourseReportsChartComponent,
    PasswordModalComponent
  ],
  imports: [
    CommonModule,
    CourseRoutingModule,
    NgxDatatableModule,
    NgbModule,
    PipeModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxSpinnerModule,
    MatSlideToggleModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyBhVQKXquGT9zTznHXq1A6YJCcrrC5HWv8",
      libraries: ['places']
    }),
    QuillModule.forRoot(),
    MatMenuModule,
    NgxChartsModule,
    MatInputModule,
    MatFormFieldModule,
    
   
  ],
})
export class CourseModule { }
